import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { HelpFormRequest } from "swagger/models"
import { HelpFormApi } from "../../../swagger/api"
import { Configuration } from "../../../swagger/configuration"
import { getFirebaseIDToken } from "../auth/firebase"

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken
}

const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    //@ts-ignore
    accessToken: getAccessToken,
  })

const apiConfiguration = getApiConfig()

const HELP_API = new HelpFormApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const sendHelpForm = async (body: HelpFormRequest, options?: AxiosRequestConfig) =>
  HELP_API.sendHelpForm(body, options)
